import { render, staticRenderFns } from "./dwguandao.vue?vue&type=template&id=4fe3f06c&scoped=true"
import script from "./dwguandao.vue?vue&type=script&lang=js"
export * from "./dwguandao.vue?vue&type=script&lang=js"
import style0 from "./dwguandao.vue?vue&type=style&index=0&id=4fe3f06c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe3f06c",
  null
  
)

export default component.exports